import { useEffect, useMemo, useState } from "react";
import SEO from "@/components/SEO";
import Breadcrumbs from "@/components/Breadcrumbs";
import { KineticLines } from "@/components/Motion";
import { PostCard } from "@/components/Cards";
import CTASection from "@/components/CTASection";
import api from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [active, setActive] = useState("All");

  useEffect(() => { api.get("/posts").then((r) => setPosts(r.data)).catch(() => {}); }, []);

  const categories = useMemo(() => ["All", ...new Set(posts.map((p) => p.category))], [posts]);
  const filtered = active === "All" ? posts : posts.filter((p) => p.category === active);

  return (
    <div data-testid="insights-page">
      <SEO title="Insights — Cleanroom Technology & Engineering" path="/insights"
        description="Technical insights from STJ Innovations on cleanroom technology, pass boxes, LAF systems, stainless steel fabrication and pharmaceutical engineering." />
      <section className="blueprint-dark bg-ink">
        <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-24">
          <Breadcrumbs dark items={[{ label: "Insights" }]} />
          <p className="eyebrow eyebrow-light">Insights</p>
          <KineticLines lines={["Engineering Notes", "& Industry Insights"]}
            className="mt-5 font-display text-4xl font-medium leading-[1.06] tracking-tight text-white sm:text-5xl" />
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-400">
            Practical writing on cleanroom technology, equipment selection and fabrication — from the STJ engineering desk.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="flex flex-wrap gap-2" role="tablist" aria-label="Filter articles by category">
          {categories.map((c) => (
            <button key={c} data-testid={`blog-filter-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              role="tab" aria-selected={active === c} onClick={() => setActive(c)}
              className={`border px-4 py-2 font-mono text-[11px] uppercase tracking-[0.15em] transition-colors ${active === c ? "border-accent bg-accent text-white" : "border-line bg-white text-steel hover:border-accent/50"}`}>
              {c}
            </button>
          ))}
        </div>
        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="posts-grid">
          {filtered.map((p, i) => <PostCard key={p.slug} post={p} index={i} />)}
        </div>
      </section>
      <CTASection />
    </div>
  );
}
